import { Box, TextField, Typography } from "@material-ui/core"
import { FormikProps } from "formik"
import { HourReportFormState } from "../../schemas"
import { useTranslation } from "react-i18next"

type Props = {
  formik: FormikProps<HourReportFormState>
}

export const DescriptionInput = ({ formik }: Props) => {
  const { t } = useTranslation("hour-report")
  const { values, handleChange, errors, touched } = formik

  return (
    <Box mt={3}>
      <Typography variant="subtitle2" gutterBottom>
        {t("form.description", { defaultValue: "Description" })}
      </Typography>
      <TextField
        name="description"
        value={values.description || ""}
        onChange={handleChange}
        variant="outlined"
        margin="dense"
        error={touched.description && Boolean(errors.description)}
        helperText={touched.description && errors.description}
        minRows={2}
        multiline
        fullWidth
      />
    </Box>
  )
}
